import Socket from 'socket.io-client';
import { URL_API } from './urlsApi';

const socket = Socket(URL_API);

export default socket;